import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { DocumentsPrefFormComponent } from './form/documents-pref-form.component'
import { DocumentSignerNotificationsComponent } from './form/document-signer-notifications/document-signer-notifications.component'
import { DocumentUserNotificationsComponent } from './form/document-user-notifications/document-user-notifications.component'

const components = [
  //
  DocumentSignerNotificationsComponent,
  DocumentUserNotificationsComponent,
  DocumentsPrefFormComponent,
]

const modules = [
  //
  SharedModule,
]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  exports: [...components, modules],
})
export class DocumentsPrefSharedModule {}
